export default function PaymentBadge({ paymentRequested }) {
  return paymentRequested
    ? <span className="pill is-payment pay-requested">Bounty requested</span>
    : <span className="pill is-payment pay-none">No payment requested</span>;
}
